// extracted by mini-css-extract-plugin
export default {"campoComValorErrado":"AlterarSenha_campoComValorErrado__yWJkt"};